angular.module("Main").controller("AggregatorStep1Controller", ["$rootScope", "$scope", "$localStorage", "$state", "$window", "$stateParams", "$location", "$translate", "AggregatorService", "BookingService", "SessionService",
    function ($rootScope, $scope, $localStorage, $state, $window, $stateParams, $location, $translate, AggregatorService, BookingService, SessionService) {
        var vm = this;

        if (!_.isEmpty($stateParams.club)) {
            vm.withoutClubsMenuItem = true;
            vm.mandantNr = $stateParams.club;
            loadAggregatorenConfig();
        } else {
            vm.withoutClubsMenuItem = false;
            vm.cookies = SessionService.checkSession();
            if (!_.isNil(vm.cookies.aggregatorClubData)) {
                vm.clubData = vm.cookies.aggregatorClubData;
                vm.mandantNr = vm.clubData.selectedMandantNr;
                vm.mandatBezeichnung = vm.clubData.selectedMandantName;
                loadAggregatorenConfig();
            }
        }

        SessionService.clear('aggregatorMemberData');

        start2();

        function start2() {
            vm.cookies = SessionService.checkSession();
            init2();
        }

        function init2() {
            if (_.isNil(vm.cookies.aggregatorData) || _.isNil(vm.cookies.aggregatorData)) {
                if (!_.isEmpty($stateParams.club)) {
                    $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
                } else {
                    $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
                }
            }
        }

        var xlarge = 1700;
        var large = 1500;
        var medium = 1200;
        var small = 900;
        var xs = 450;

        function checkLimitLength() {
            if ($window.innerWidth >= xlarge) {
                vm.limitLength = 8;
            }
            else if ($window.innerWidth >= large) {
                vm.limitLength = 6;
            }
            else if ($window.innerWidth >= medium) {
                vm.limitLength = 5;
            } else if ($window.innerWidth >= small) {
                vm.limitLength = 4;
            } else if ($window.innerWidth >= xs) {
                vm.limitLength = 3;
            }
        }

        checkLimitLength();

        function loadAggregatorenConfig() {
            vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
            BookingService.loaAggregatorenText(vm.mandant).then(function (data) {
                vm.aggregatorenConfigtext = data;
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                getKursbuchungLayouKonfiguration();
            })
        }

        function loadCurrency() {

            return new Promise((resolve) => {
                BookingService.getCurrency().then(function (data) {
                    vm.currency = data;
                    if (vm.currency.Waehrung === "EUR")
                        vm.currency.Waehrung = "€";
                    resolve(vm);
                })

            })
        }

        //ToDo prüfen was wenn id false/ abfangen => kein Link
        if (!SessionService.getSessionId()) {
            if (_.isUndefined($stateParams.id)) {
                SessionService.setAuthDataId($stateParams.cid, false);
                $state.go('aggregator_overview', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: false, club: $stateParams.club});
            } else {
                SessionService.setAuthDataId($stateParams.cid, $stateParams.id, false);
                $state.go('aggregator_overview', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            }
            start();
        } else
            start();

        async function start() {
            try {
                await loadCurrency();
                init();
            }
            catch {

            }
        }

        async function init() {
            try {
                await loadConfigs();
                await checkAggregatoren()
            }
            catch {

            }
        }

        function checkAggregatoren() {
            SessionService.clear('aggregatorData');
            vm.linkInactiv = false;
           AggregatorService.checkAggregatorenLinkConfig($stateParams.id).then(function (data) {
                if (data.data.LinkIdNotFound === true || data.data.IsInactiv) {
                    vm.linkInactiv = true;
                    vm.isInFuture = data.IsInFuture;
                    vm.isInPast = data.IsInPast;
                    if (data.data.IsInFuture === true) {
                        vm.futureDate = data.data.FutureDate;
                    }
                } else {
                    if(data.data.Aggregator.length===0) {
                        vm.linkInactiv = true;
                    }
                    else {
                        vm.allAggregatoren = _.orderBy(data.data.Aggregator, [
                            (item) => (item.Sortierung === 0 ? Infinity : item.Sortierung)
                        ], ['asc']);

                        if (vm.limitLength) {
                            vm.chunckedAggregatoren = _.chunk(vm.allAggregatoren, vm.limitLength);
                            vm.aggregators = vm.chunckedAggregatoren[0];
                            vm.showMover = vm.allAggregatoren.length > vm.limitLength;
                            vm.begin = 0;
                        } else {
                            vm.aggregators = vm.allAggregatoren;
                        }

                    }
                }
            })
        }

        vm.selectAggregator = function (aggregator) {

            SessionService.setAggregatorData(aggregator);
            $state.go('aggregator_register', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club})

        };

        vm.moveLeft = function () {
            vm.begin--;
            if (vm.begin < 0) {
                vm.begin = 0;
            }
            vm.aggregators = vm.chunckedAggregatoren[vm.begin];
        };

        vm.moveRight = function () {
            vm.begin++;
            if (vm.begin + 1 > vm.chunckedAggregatoren.length) {
                vm.begin = 0
            }
            vm.aggregators = vm.chunckedAggregatoren[vm.begin];
        };

        vm.goToAngebot = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            vm.openedMenuBar = false;
        }

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

        vm.goBackAggregatorClubs = function () {
            $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        }

    }])